
import { ErrorsTranslationType } from "../../features/errors.types";

export const errors: ErrorsTranslationType = {
  errors: {
    error: "错误",
    notFound: "找不到页面",
    deleteAccountError: "删除账户时出错。请重试。",
    loadStoryError: "加载故事时出错。请重试。",
    loadCharactersError: "加载角色时出错。请重试。",
    summaryError: "生成摘要时出错。请重试。"
  }
};
